import { AxiosError } from "axios";
import { LoadingBlurDiv } from "@shared/components";
import { usePrivacyPolicyQuery } from "../api";
import { buildAssetUrl } from "@shared/utils";
import PrivacyPolicyTab from "../components/organisms/PrivacyPolicyTab";

const PrivacyPolicyPage = () => {
  const { data, error, isFetching } = usePrivacyPolicyQuery();

  const isNotFound = (error as AxiosError)?.response?.status === 404;
  const storagePath = data?.storagePath ? buildAssetUrl(data.storagePath) : undefined;

  return (
    <LoadingBlurDiv isLoading={isFetching}>
      <PrivacyPolicyTab
        storagePath={storagePath}
        isFetching={isFetching}
        isNotFound={isNotFound}
      />
    </LoadingBlurDiv>
  );
};

export default PrivacyPolicyPage;

